module.exports = __webpack_public_path__ + "static/media/baalOgGrill.d8142e1b.svg";